<script>
	import router from "page"
	import Info from './Info.svelte'
	import Checkout from './Checkout.svelte'
	import Completed from './Completed.svelte'
	import Failed from './Failed.svelte'
	import About from './About.svelte'

	let year = new Date().getFullYear();

	let page;
	let params;
	router('/', () => page = Info);
	router('/checkout', () => page = Checkout);
	router('/completed', () => page = Completed);
	router('/failed', () => page = Failed);
	router('/about', () => page = About);

	router.start();
</script>

<svelte:head>
    <script src="https://js.stripe.com/v3/"></script>
</svelte:head>

<main class="min-h-screen">
	<div id="holdsall" class="bg-gray-100 text-purple-900 font-nunito flex flex-col h-auto min-h-screen relative">
		<navbar class="navbar flex sm:text-md md:text-lg text-white text-center py-1 items-center w-full bg-purple-700">	
			<a href="/">
				<div class="ml-2 flex px-2 items-center hover:bg-purple-400 rounded">
					<img id="postcard-main" class="block" src="postcard-main.png" alt="Sendcard">
					<div class="font-bold sm:text-lg md:text-2xl py-2 ml-2">
						Sendcard
					</div>
				</div>
			</a>
			<div class="flex-auto"/>
			<div class="sm:mx-2 md:mx-6 flex">
				<a href="/">
					<div class="sm:mr-0 md:mr-2 px-2 py-2 hover:bg-purple-400 rounded">
						New card
					</div>
				</a>
				<a href="/about">
					<div class="px-2 py-2 hover:bg-purple-400 rounded">
						About
					</div>
				</a>
			</div>
		</navbar>
		<div id="content-container" class="container mx-auto h-full">
			<svelte:component this={page} {params}/>
		</div>
		<footer id="footsies" class="text-sm md:text-md text-center text-white justify-center bg-purple-700 py-6 flex flex-col">
			<div class="h-1/2">
				Copyright &copy; {year} Trevor Stenson. Made with <a href="https://svelte.dev/"><img id="svelteIcon" src="svelte-icon.png" alt="Svelte"></a>
			</div>
		</footer>
	</div>
	
</main>

<style>
	main {
		text-align: center;
		/* max-width: 240px; */
		margin: 0 auto;
		min-height: 100vh;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}

	#svelteIcon {
		height: 24px;
		display: inline;
	}

	#postcard-main {
		filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%) contrast(103%);
		width: max(28px, 2.7vw);
	}

	#holdsall {
		padding-bottom: 2.5rem;
	}

	#footsies {
		position: absolute;
		bottom: 0;
		width: 100%;
		height: 2.5rem;
	}
</style>